import React from 'react';
import ReaderTypeForm from './components/ReaderTypeForm';

const ReaderTypeEditPage: React.FC = () => {
  return <ReaderTypeForm isEdit />;
};

export default ReaderTypeEditPage;